export const ERROR_MIDDLEWARE = "ERROR_MIDDLEWARE";
